import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import Form, { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule, CheckBox } from "devextreme-react/form";
import Request from "../../components/Request/Request";
//import * as AppActions from '../../../actions/AppActions';
import { ToastType } from "../../constants/Constants";
import { showToast, parseDate, hasRole } from "../../utils/Utils";
import * as AppActions from '../../actions/AppActions';
const HesapDetayDuzenleForm = (props) => {

    const dispatch = useDispatch();

    const [data, setData] = useState();
    const [storeHesaplaDetayTuru, setStoreHesaplaDetayTuru] = useState([]);

    useEffect(() => {
        getData();
        setHesaplaDetayTuruList();
    }, [])

    function setHesaplaDetayTuruList() {
        if (!storeHesaplaDetayTuru || storeHesaplaDetayTuru.length == 0) {
            const request = new Request("/emeklilik-app/api/enum-tanim/getList/HesaplaDetayTuru", "GET");
            request.run()
                .then(response => {
                    if (response.data && response.data.data) {
                        setStoreHesaplaDetayTuru(response.data.data);
                    }
                });
        }
    }


    const getData = () => {

        let id = -1;
        if (props.data && props.data.id) {
            id = props.data.id;
        } else {
            setData(props.data);
            return;
        } 
        dispatch(AppActions.setLoading(true, "Kayıt Yükleniyor.."));
        const request = new Request("/emeklilik-app/api/personel-ek-hesap-bilgi/getKayit/" + id, "GET");
        return request.run()
            .then(response => {
                setData(response.data.data);
                dispatch(AppActions.setLoading(false, ""));
            });
    }
    function kaydet(e) {

        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }

        let formData = data;

        let method = "POST"
        let url = "/emeklilik-app/api/personel-ek-hesap-bilgi/save";

        const request = new Request(url, method, formData);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });


    }


    return (
        <div >
            <Form formData={data} colCount={1} id="form" labelLocation={"left"} className="option" >

                <Item disabled={false} dataField={'detayTuru'} editorType={'dxSelectBox'}
                    editorOptions={{
                        dataSource: storeHesaplaDetayTuru,
                        valueExpr: "id",
                        displayExpr: "name",
                        placeholder: "Select a value...",
                        //stylingMode: 'outlined',
                    }}>
                    <RequiredRule message="Detay Tipi bilgisi gerekli" />
                    <Label text='Hesap Türü' />
                </Item>
                <Item disabled={false} dataField={'secili'} editorType={'dxCheckBox'} > 
                    <Label text='Seçim' />
                </Item>

                <Item disabled={false} dataField={'baslangicTarihi'} editorType={'dxDateBox'}
                    editorOptions={{
                        displayFormat: "yyyy-MM-dd"
                    }}>
                    <RequiredRule message="Başlangıç Tarihi bilgisi gerekli" />
                    <Label text='Başlangıç Tarihi' />
                </Item>
                <Item disabled={false} dataField={'bitisTarihi'} editorType={'dxDateBox'}
                    editorOptions={{
                        displayFormat: "yyyy-MM-dd"
                    }}>
                    <Label text='Bitiş Tarihi' />
                </Item>    

                <ButtonItem>
                    <ButtonOptions
                        onClick={(e) => { kaydet(e); }}
                        width={'100%'}
                        type={'success'}
                        useSubmitBehavior={true}>
                        <span className="dx-button-text">
                            {'Kaydet'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>

            </Form>


        </div>
    )
}

export default HesapDetayDuzenleForm;
